import { FC } from "react";
import useEvent from "react-use-event-hook";

import { PIC } from "@ryde/assets";
import { StarredDisplayModeEnum } from "@ryde/shared";

import { StarredIconExcludeWrap } from "./starred-icon.styled";
import { getStarFillColor, getStarStrokeColor } from "./starred-utils";

interface IStarredIcon {
  starredDisplayMode: StarredDisplayModeEnum;
  strokeColor?: string;
  onCheckboxToggle?: () => void;
}

export const StarredIcon: FC<IStarredIcon> = ({
  starredDisplayMode,
  onCheckboxToggle,
}) => {
  const toggleChecked = useEvent((): void => {
    onCheckboxToggle?.();
  });
  const color = getStarFillColor(starredDisplayMode);
  const border = getStarStrokeColor(starredDisplayMode);
  const body = (
    <div className="starred-icon__container">
      <PIC.TableStarSvg
        fill={color}
        stroke={border}
        onClick={toggleChecked}
        className="starred_icon"
      />
    </div>
  );

  if (starredDisplayMode === StarredDisplayModeEnum.ShowAllWithoutStarred) {
    return <StarredIconExcludeWrap>{body}</StarredIconExcludeWrap>;
  }

  return body;
};
